import { Component ,  OnInit , Input , AfterViewInit , ViewChild , ElementRef , forwardRef, EventEmitter, Output, HostListener} 	from '@angular/core';


@Component({
        standalone: false,
  selector: 'uikit-consent-modal',
  templateUrl: "./uikit.consent.modal.html",
  styles : [
	`
		.donationdrive-modal-parent {
			position: absolute;
			left: 50%;
			z-index: 100;
			min-width : 50%;
			max-width : 90%;
		}
		.ui_modal.donationdrive-modal {
			position: relative;
			z-index: 101;
			max-width: 90%;
			left: -50%;
		}
		@media (max-width:767px) {
			.ui_modal.donationdrive-modal {
				max-width: 94%;
				margin-left: 3%;
			}
			.donationdrive-modal-parent {
				min-width : 85%;
			}
			.donationdrive-modal-parent .ui_modal .ui_modal_btns .ui_btn.ui_btn_primary {
				margin-top : 10px;
			}
		}
	`

  ]
})
export class UiKitConsentModalComp implements OnInit , AfterViewInit  {

			
	@Output() close:any = new EventEmitter<any>();
	@Input() forChild:boolean = false;
	@Input() consent:any = null;
	@Input() namesList:any = null;
	
	showing:boolean = false;
	initialized:boolean = false;
	username:string = null;
	parentalPassword:string = null;

	@Input()
	modalResponse:any;

	@Input()
	currUserName:string = null;
	showError:boolean = false;
	showPasswordError:boolean = false;
    constructor(private _el: ElementRef){
    }

    ngOnInit(){
		this.initialized=true;
		//console.info( " ************************************************** ");
    }
		
	ngAfterViewInit() {
	}	

	action( selval:string ){
		console.info( " action : "+ selval  );
		if( selval == 'yes' && ( this.username == null || this.username.trim() == '') ){
			this.showError = true;
			return;
		}else if( selval == 'yes' && this.forChild ==true && ( this.parentalPassword == null || this.parentalPassword.trim() == '') ) {
			this.showPasswordError = true;
		}
		
		/*if( this.forChild == true ) {
			this.change.emit( selval+","+this.parentalPassword );
		}else {
			this.change.emit( selval );
		}*/
		if( this.modalResponse.owner != null && this.modalResponse.func != null ){
			var resp = false;
			if( this.forChild == false )
				resp = this.modalResponse.func.call( this.modalResponse.owner , selval , this.consent );
			else 
			resp = this.modalResponse.func.call( this.modalResponse.owner , selval , this.consent  , this.parentalPassword );
			
			if( resp == true ){
				this.close.emit();
			}
		}
	}

	closeIcon(){
		this.close.emit();
	}

	usernameChanged( event:any ){
		if( this.username != null )
				this.showError = false;
	}

	passwordChanged( event:any ){
		if( this.parentalPassword != null )
				this.showPasswordError = false;
	}


}